export const STORAGE_KEYS = {
  ACCESS_TOKEN: "accessToken",
  KEYCLOAK_USER_ID: "keycloakUserId",
  USER_EMAIL: "userEmail",
  TENANT_ID: "tenantId",
  ORG_CREATED: "orgCreated",
  ORG_NAME: "orgName",
  ORG_ID: "orgId",
  WORKSPACE_URL: "workspaceUrl",
}

export const STATUS = {
  ONLINE: "ONLINE",
  OFFLINE: "OFFLINE",
  ALERT: "ALERT",
  ACTIVE: "active",
  INACTIVE: "inactive",
}

export const SEVERITY = {
  ERROR: "error",
  SUCCESS: "success",
  WARNING: "warning",
  INFO: "info",
}

export const DEVICE_TYPE = {
  CAMERA: "Camera",
  HUB: "Hub",
  NVR: "NVR",
}

export const ENTITY_TYPE = {
  ORG: "org",
  SITE: "site",
  FLOOR: "floor",
  SPACE: "space",
}

export const EVENT_MODE = {
  VIDEO: "video",
  IMAGE: "image",
  DEFAULT: "default",
}

export const BUTTON_LABELS = {
  BACK: "Back",
  CONTINUE: "Continue",
  SAVE: "Save",
  CLOSE: "Close",
  CANCEL: "Cancel",
  CONFIRM: "Confirm",
  DELETE: "Delete",
  EDIT: "Edit",
  UPDATE: "Update",
  CREATE: "Create",
  DONE: "Done",
}

export const MESSAGES = {
  ORG_CREATED: "Organization created successfully!",
  ORG_UPDATED: "Organization updated successfully!",
  ORG_DELETED: "Organization deleted successfully!",
  SITE_CREATED: "Site created successfully!",
  SITE_UPDATED: "Site updated successfully!",
  SITE_DELETED: "Site deleted successfully!",
  DEVICE_ONBOARDED: "Device onboarded successfully!",
  GENERIC_ERROR: "Something went wrong. Please try again.",
}

export const VALIDATION = {
  SELECT_DEVICE_TYPE: "Please select a device type",
  ENTER_DEVICE_NAME: "Please enter a device name",
  SELECT_ORGANIZATION: "Please select an organization",
  SELECT_SITE: "Please select a site",
  SELECT_FLOOR: "Please select a floor",
  SELECT_SPACE: "Please select a space",
  ORG_NAME_REQUIRED: "Organization name is required",
  SHORT_NAME_REQUIRED: "Short name is required",
  ADDRESS_REQUIRED: "Address is required",
  SELECT_TIMEZONE: "Please select a timezone",
  INVALID_URL: "Invalid workspace URL",
}

export const CSS_CLASSES = {
  PRIMARY_BUTTON: "primaryButton",
  SECONDARY_BUTTON: "secondaryButton",
  CUSTOM_SELECT: "customSelect",
  CUSTOM_MENU: "customMenu",
  CUSTOM_FORM_INPUT: "customFormInput",
  CUSTOM_FORM_MENU: "customFormMenu",
}

export const HTTP = {
  HEADERS: {
    CONTENT_TYPE: "Content-Type",
    AUTHORIZATION: "Authorization",
  },
  CONTENT_TYPES: {
    JSON: "application/json",
  },
  METHODS: {
    POST: "POST",
    DELETE: "DELETE",
  },
}

export const TIMEZONES = [
  { label: "UTC-12:00", value: "UTC-12:00" },
  { label: "UTC-08:00 (PST)", value: "UTC-08:00" },
  { label: "UTC-07:00 (MST)", value: "UTC-07:00" },
  { label: "UTC-06:00 (CST)", value: "UTC-06:00" },
  { label: "UTC-05:00 (EST)", value: "UTC-05:00" },
  { label: "UTC+00:00 (GMT)", value: "UTC+00:00" },
  { label: "UTC+01:00 (CET)", value: "UTC+01:00" },
  { label: "UTC+05:30 (IST)", value: "UTC+05:30" },
  { label: "UTC+08:00 (CST)", value: "UTC+08:00" },
  { label: "UTC+09:00 (JST)", value: "UTC+09:00" },
  { label: "UTC+12:00 (NZST)", value: "UTC+12:00" },
]

// ── Roles ───────────────────────────────────────────────────────────────────
export const MEMBER_ROLE = {
  SUPER_ADMIN: "Super Admin",
  ADMIN: "Admin",
  OPERATOR: "Operator",
  IT_ADMIN: "IT Admin",
  VIEWER: "Viewer",
  PIN_ROLE : "super_admin"
}

export const MEMBER_STATUS = {
  ACTIVE: "ACTIVE",
  EXPIRED: "EXPIRED",
  PENDING: "PENDING",
  INACTIVE: "INACTIVE",
  INVITED: "INVITED",
  CANCELLED: "CANCELLED",
  DELETED : "DELETED",
}

export const BADGE_VARIANT = {
  PRIMARY: "primary",
  ACCENT: "accent",
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  NEUTRAL: "neutral",
  NEUTRALDARK: "neutraldark",
  SUPER_ADMIN: "superAdmin",
  WARNINGDARK: "warningdark",
  EXPIRED: "expired",
}

// Variant → predefined design-system classes (see tailwind.config.js).
export const BADGE_VARIANT_STYLES = {
  [BADGE_VARIANT.PRIMARY]: "bg-primary1-extra-100 text-primary1-extra-600",
  [BADGE_VARIANT.ACCENT]: "bg-primary2-200 text-primary2-800",
  [BADGE_VARIANT.SUCCESS]: "bg-success-100 text-success-600",
  [BADGE_VARIANT.ERROR]: "bg-error-100 text-error-800",
  [BADGE_VARIANT.WARNING]: "bg-warning-100 text-warning-800",
  [BADGE_VARIANT.NEUTRAL]: "bg-secondary-100 text-[var(--badge-neutral-text)] border-secondary-300",
  [BADGE_VARIANT.NEUTRALDARK]: "bg-secondary-200 text-secondary-500",
  [BADGE_VARIANT.SUPER_ADMIN]: "bg-primary1-100 text-primary1-600",
  [BADGE_VARIANT.EXPIRED]: "bg-secondary-200 text-secondary-500",
  [BADGE_VARIANT.WARNINGDARK]: "bg-primary2-50 text-primary2-800",}

// Layout-only base. Colour comes from BADGE_VARIANT_STYLES, and
// spacing/size/radius/weight come from the token maps below, so each visual
// dimension can be overridden independently.
export const BADGE_BASE_STYLE = "inline-flex items-center tracking-wide"

// Size → padding + font-size. Add a key here to expose a new size.
export const BADGE_SIZE = {
  XS: "xs",
  SM: "sm",
  MD: "md",
  LG: "lg",
}

// Each size splits padding and font-size so the Badge `padding` prop can
// replace the padding without disturbing the font-size.
export const BADGE_SIZE_STYLES = {
  [BADGE_SIZE.XS]: { padding: "px-1.5 py-0.5", text: "text-[10px]" },
  [BADGE_SIZE.SM]: { padding: "px-1.5 py-0.5", text: "text-xs" },
  [BADGE_SIZE.MD]: { padding: "px-1.5 py-1", text: "text-xs" }, // previous default
  [BADGE_SIZE.LG]: { padding: "px-3 py-1.5", text: "text-sm" },
}

// Border radius tokens.
export const BADGE_RADIUS = {
  NONE: "none",
  SM: "sm",
  BASE: "base", // Tailwind's default `rounded` (0.25rem)
  MD: "md",
  LG: "lg",
  FULL: "full",
}

export const BADGE_RADIUS_STYLES = {
  [BADGE_RADIUS.NONE]: "rounded-none",
  [BADGE_RADIUS.SM]: "rounded-sm", // previous default
  [BADGE_RADIUS.BASE]: "rounded",
  [BADGE_RADIUS.MD]: "rounded-md",
  [BADGE_RADIUS.LG]: "rounded-lg",
  [BADGE_RADIUS.FULL]: "rounded-full",
}

export const BADGE_DEFAULTS = {
  size: BADGE_SIZE.MD,
  radius: BADGE_RADIUS.MD,
  weight: "semibold", // maps to Tailwind's font-weight tokens, e.g. "normal" | "medium" | "semibold"
}